// Real calendar math (not mock) for the annual/monthly allowance progress charts.
// Simplified to calendar year (Jan 1 – Dec 31) rather than the org's actual financial
// year start month — that field isn't exposed to the frontend yet.
function daysBetween(from, to) {
  const msPerDay = 24 * 60 * 60 * 1000;
  return Math.round((to.getTime() - from.getTime()) / msPerDay);
}

export function getAnnualPeriod(now = new Date()) {
  const yearStart = new Date(now.getFullYear(), 0, 1);
  const yearEnd = new Date(now.getFullYear() + 1, 0, 1);
  return {
    daysElapsed: daysBetween(yearStart, now),
    daysToReset: daysBetween(now, yearEnd),
  };
}

export function getMonthlyPeriod(now = new Date()) {
  const monthStart = new Date(now.getFullYear(), now.getMonth(), 1);
  const monthEnd = new Date(now.getFullYear(), now.getMonth() + 1, 1);
  return {
    daysElapsed: daysBetween(monthStart, now),
    daysToReset: daysBetween(now, monthEnd),
  };
}

/**
 * Days elapsed/to-reset for an arbitrary month, selected by the month dropdown.
 * monthsAgo=0 is the current (real, partial) month — delegates to getMonthlyPeriod.
 * A past month is, by definition, fully elapsed (daysToReset=0): "days to reset" only
 * makes sense for the month that's actually in progress.
 * @param {number} monthsAgo - 0 = current month, 1 = last month, etc.
 */
export function getMonthPeriodByOffset(monthsAgo, now = new Date()) {
  if (monthsAgo === 0) return getMonthlyPeriod(now);
  const monthStart = new Date(now.getFullYear(), now.getMonth() - monthsAgo, 1);
  const monthEnd = new Date(now.getFullYear(), now.getMonth() - monthsAgo + 1, 1);
  return {
    daysElapsed: daysBetween(monthStart, monthEnd),
    daysToReset: 0,
  };
}

/**
 * Builds the last N months (including the current one) as {label, monthsAgo} options
 * for a month-selector dropdown, newest first.
 */
export function getRecentMonthOptions(count = 12, now = new Date()) {
  const options = [];
  for (let monthsAgo = 0; monthsAgo < count; monthsAgo++) {
    const date = new Date(now.getFullYear(), now.getMonth() - monthsAgo, 1);
    options.push({
      monthsAgo,
      label: date.toLocaleDateString("en-GB", { month: "long", year: "numeric" }),
    });
  }
  return options;
}

// A rolling 30-day window has no calendar "reset" — it just keeps sliding forward.
// Treat it as fully elapsed (daysToReset=0) so the pace projection collapses to raw
// % used, which is the correct comparison for a trailing window (there's no "ahead of
// pace" for a window that's always fully in the past).
export function getTrailing30DaysPeriod() {
  return { daysElapsed: 30, daysToReset: 0 };
}
